export const DIQAdminRoleName = 'DIQAdmin';
export const TeamManagerRoleName = 'TeamManager';
export const DIQSupportRoleName = 'DIQSupport';
export const AdminRoleName = 'Admin';
export const RepRoleName = 'Rep';
export const excludeTeamManager = [DIQAdminRoleName, DIQSupportRoleName, AdminRoleName];
